/*
 * Rescuevation Warenkorb-Schublade (Vorschau drw-a/b) und Hinweis-Popup (drw-c).
 * Hängt sich in Dawns <cart-drawer> ein, statt snippets/cart-drawer.liquid zu
 * ändern: getSectionsToRender zeigt auf sections/rescu-drw-<x>.liquid, damit
 * "In den Warenkorb" (product-form.js) direkt den neuen Inhalt mitliefert.
 * Mengenänderung in der Schublade: cart/change.js mit sections=…, Inhalt tauschen.
 */
(() => {
  const marker = document.querySelector('[data-rescu-drw]');
  if (!marker || window.__rescuDrw) return;
  window.__rescuDrw = true;

  const V = marker.dataset.rescuDrw;
  const SEC = `rescu-drw-${V}`;
  const root = window.Shopify?.routes?.root || '/';
  const vorschau = /[?&]view=drw-/.test(window.location.search);
  const parse = (html) => new DOMParser().parseFromString(html, 'text/html');
  const drawer = () => document.querySelector('cart-drawer');
  const pop = document.getElementById('RescuHinweis');

  // In der Vorschau führen Warenkorb-Links auf die Kassen-Vorschau
  function kassenLinks(scope) {
    if (!vorschau || !scope) return;
    scope.querySelectorAll('a[data-drw-kasse]').forEach((a) => {
      const u = new URL(a.getAttribute('href'), window.location.origin);
      a.setAttribute('href', `${u.pathname}?view=kasse-a${u.hash}`);
    });
  }

  function blase(html) {
    const ziel = document.getElementById('cart-icon-bubble');
    const neu = html && parse(html).querySelector('.shopify-section');
    if (ziel && neu) ziel.innerHTML = neu.innerHTML;
  }

  // Tastaturfokus über den Inhaltstausch retten: gleiche Position, gleiches Bedienelement
  function fokusMerken(ziel) {
    const a = document.activeElement;
    if (!a || !ziel.contains(a)) return null;
    const pos = a.closest('[id^="DrwPos-"]')?.id || null;
    const merkmal = ['data-drw-step', 'data-drw-line', 'data-drw-remove', 'data-drw-weg', 'data-drw-add']
      .find((m) => a.hasAttribute(m));
    return { pos, merkmal, wert: merkmal ? a.getAttribute(merkmal) : null };
  }
  function fokusSetzen(ziel, f) {
    if (!f) return;
    let el = null;
    if (f.merkmal && f.merkmal !== 'data-drw-remove') {
      const bereich = f.pos ? ziel.querySelector(`#${f.pos}`) : ziel;
      el = bereich?.querySelector(`[${f.merkmal}="${f.wert}"]`) || null;
    }
    (el || ziel.querySelector('.drawer__inner'))?.focus({ preventScroll: true });
    if (typeof window.trapFocus === 'function' && drawer()?.classList.contains('active')) {
      window.trapFocus(ziel, el || ziel.querySelector('.drawer__inner'));
    }
  }

  function fehler(text) {
    const ziel = document.querySelector('#CartDrawer [data-drw-fehler]');
    if (!ziel) return;
    ziel.textContent = text || '';
    ziel.hidden = !text;
  }

  function schubladeSetzen(html) {
    const neu = parse(html).querySelector('#CartDrawer');
    const ziel = document.getElementById('CartDrawer');
    const d = drawer();
    if (!neu || !ziel || !d) return;
    const fokus = fokusMerken(ziel);
    ziel.innerHTML = neu.innerHTML;
    d.classList.toggle('is-empty', !!ziel.querySelector('.drw.is-empty'));
    ziel.querySelector('#CartDrawer-Overlay')?.addEventListener('click', () => d.close());
    kassenLinks(ziel);
    nachRender();
    fokusSetzen(ziel, fokus);
  }

  // ── zweite Runde B: Wegwahl merken (b2), Lieferfenster + Zubehör (b3) ──
  let weg = null;
  const werktage = (n) => {
    const t = new Date();
    let z = 0;
    while (z < n) { t.setDate(t.getDate() + 1); const w = t.getDay(); if (w !== 0 && w !== 6) z++; }
    return t;
  };

  let empfRunde = 0;
  async function zubehoer(box) {
    const id = box.dataset.productId;
    const liste = box.querySelector('[data-drw-empf-liste]');
    if (!id || !liste) return;
    const runde = ++empfRunde;
    try {
      const html = await fetch(`${root}recommendations/products?product_id=${id}&limit=6&intent=related&section_id=rescu-drw-empf`).then((r) => r.text());
      if (runde !== empfRunde || !box.isConnected) return;
      const neu = parse(html).querySelector('.drw-empf__liste');
      if (neu && neu.children.length) { liste.innerHTML = neu.innerHTML; box.hidden = false; }
    } catch (e) { /* ohne Empfehlungen bleibt der Block verborgen */ }
  }

  function nachRender() {
    const ziel = document.getElementById('CartDrawer');
    if (!ziel) return;
    const radio = weg && ziel.querySelector(`[data-drw-weg][value="${weg}"]`);
    if (radio) radio.checked = true;
    const termin = ziel.querySelector('[data-drw-termin]');
    if (termin) {
      const von = werktage(5);
      const bis = werktage(10);
      const monate = ['Jan.', 'Feb.', 'März', 'Apr.', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
      const monat = (d) => monate[d.getMonth()];
      const spanne = von.getMonth() === bis.getMonth()
        ? `${von.getDate()}.–${bis.getDate()}. ${monat(bis)}`
        : `${von.getDate()}. ${monat(von)}–${bis.getDate()}. ${monat(bis)}`;
      termin.textContent = `Lieferung voraussichtlich ${spanne}`;
    }
    const empf = ziel.querySelector('[data-drw-empf]');
    if (empf) zubehoer(empf);
  }

  async function dazu(variante, knopf) {
    const box = document.querySelector('#CartDrawer .drw');
    if (!box || box.classList.contains('is-busy')) return;
    box.classList.add('is-busy');
    fehler('');
    knopf.disabled = true;
    try {
      const res = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variante, quantity: 1 }], sections: [SEC, 'cart-icon-bubble'], sections_url: window.location.pathname }),
      });
      const daten = await res.json();
      if (!res.ok) {
        box.classList.remove('is-busy'); knopf.disabled = false;
        fehler(res.status === 422
          ? 'Dieser Artikel ist gerade nicht in dieser Menge lieferbar.'
          : (daten.description || 'Der Artikel konnte nicht hinzugefügt werden.'));
        return;
      }
      schubladeSetzen(daten.sections[SEC]);
      blase(daten.sections['cart-icon-bubble']);
    } catch (e) {
      box.classList.remove('is-busy'); knopf.disabled = false;
      fehler('Der Artikel konnte nicht hinzugefügt werden. Bitte versuche es noch einmal.');
    }
  }

  function popZeigen(state) {
    if (!pop) return;
    const inhalt = parse(state.sections[SEC]).querySelector('.drw-hinweis-inhalt');
    pop.querySelector('[data-drw-inhalt]').innerHTML = inhalt ? inhalt.innerHTML : '';
    pop.querySelectorAll('[data-key]').forEach((el) => { el.hidden = el.dataset.key !== state.key; });
    kassenLinks(pop);
    blase(state.sections['cart-icon-bubble']);
    pop.hidden = false;
    requestAnimationFrame(() => pop.classList.add('is-offen'));
    pop.querySelector('#RescuHinweisTitel')?.focus({ preventScroll: true });
  }

  function popZu() {
    if (!pop) return;
    pop.classList.remove('is-offen');
    pop.hidden = true;
  }

  async function menge(line, quantity) {
    const box = document.querySelector('#CartDrawer .drw');
    if (!box || box.classList.contains('is-busy')) return;
    box.classList.add('is-busy');
    fehler('');
    try {
      const res = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line, quantity, sections: [SEC, 'cart-icon-bubble'], sections_url: window.location.pathname }),
      });
      const daten = await res.json();
      if (!res.ok) {
        box.classList.remove('is-busy');
        const feld = box.querySelector(`[data-drw-line="${line}"]`);
        if (feld) feld.value = feld.defaultValue;
        fehler(res.status === 422
          ? 'Mehr ist von diesem Artikel gerade nicht lieferbar. Für größere Mengen fordere gern ein Angebot an.'
          : (daten.description || 'Die Menge konnte nicht geändert werden.'));
        return;
      }
      schubladeSetzen(daten.sections[SEC]);
      blase(daten.sections['cart-icon-bubble']);
    } catch (e) {
      window.location.reload();
    }
  }

  customElements.whenDefined('cart-drawer').then(() => {
    const d = drawer();
    if (!d) return;
    d.getSectionsToRender = () => [{ id: SEC, selector: '#CartDrawer' }, { id: 'cart-icon-bubble' }];
    if (V === 'c') {
      d.renderContents = (state) => popZeigen(state);
      d.open = () => { window.location.href = vorschau ? `${root}cart?view=kasse-a` : `${root}cart`; };
      return;
    }
    const original = d.renderContents.bind(d);
    d.renderContents = (state) => {
      original(state);
      d.classList.remove('is-empty');
      kassenLinks(document.getElementById('CartDrawer'));
      nachRender();
    };
    const vorlage = document.getElementById('RescuDrwVorlage');
    if (vorlage) schubladeSetzen(vorlage.innerHTML);
    else nachRender();
    if (document.querySelector('#CartDrawer .kas-angebot__fehler') ||
        (/contact_posted=true/.test(window.location.search) && document.querySelector('#CartDrawer .drw-ok'))) {
      weg = 'angebot';
      nachRender();
      d.open();
    }
  });

  document.addEventListener('click', (e) => {
    const schritt = e.target.closest('[data-drw-step]');
    if (schritt) {
      e.preventDefault();
      const feld = schritt.closest('[data-drw-menge]')?.querySelector('[data-drw-line]');
      if (feld) menge(parseInt(feld.dataset.drwLine, 10), Math.max(0, (parseInt(feld.value, 10) || 0) + parseInt(schritt.dataset.drwStep, 10)));
      return;
    }
    const entfernen = e.target.closest('[data-drw-remove]');
    if (entfernen) { e.preventDefault(); menge(parseInt(entfernen.dataset.drwRemove, 10), 0); return; }
    const plus = e.target.closest('[data-drw-add]');
    if (plus) { e.preventDefault(); dazu(parseInt(plus.dataset.drwAdd, 10), plus); return; }
    if (e.target.closest('[data-drw-zu]')) {
      e.preventDefault();
      if (V === 'c') popZu(); else drawer()?.close();
    }
  });

  document.addEventListener('change', (e) => {
    if (e.target.matches('[data-drw-weg]')) { weg = e.target.value; return; }
    const feld = e.target.closest('[data-drw-line]');
    if (!feld) return;
    const zahl = parseInt(feld.value, 10);
    if (Number.isNaN(zahl) || zahl < 0) { feld.value = feld.defaultValue; return; }
    if (String(zahl) === feld.defaultValue) return;
    menge(parseInt(feld.dataset.drwLine, 10), zahl);
  });

  document.addEventListener('keyup', (e) => {
    if (e.key === 'Escape' && pop && !pop.hidden) popZu();
  });

  let notizTimer;
  document.addEventListener('input', (e) => {
    const notiz = e.target.closest('[data-drw-notiz]');
    if (!notiz) return;
    clearTimeout(notizTimer);
    notizTimer = setTimeout(() => {
      fetch(`${root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ note: notiz.value }),
      }).catch(() => {});
    }, 600);
  });
})();
